<!-- @format -->

<template>
	<div class="component-upload-image">
		<van-uploader
			v-model="fileList"
			multiple
			:before-read="beforeRead"
			:after-read="afterRead"
			:before-delete="handleRemove"
			:max-count="limit"
			:preview-options="previewOptions"
			:preview-full-image="false"
			v-bind="$attrs"
			:accept="accept"
			@click-upload="onClickUpload"
		>
			<template #default>
				<div v-if="props.showUpload" class="upload-input-wrap">
					<span v-if="showCamera" class="upload-input-icon" @click="onClickUploadImage">
						<el-icon size="30px"><Camera /></el-icon>
					</span>
					<span v-if="showVideo" class="upload-input-icon" @click="onClickUploadVideo">
						<el-icon size="30px"><VideoCamera /></el-icon>
					</span>
				</div>
			</template>
			<template #preview-cover="file">
				<div class="preview-cover van-ellipsis" @click="clickPreview(file)">
					<!-- {{ file.url }} -->
					<template v-if="'img' === file.resType">
						<el-image style="width: 100%; height: 100%" :src="file.url" fit="contain" />
					</template>
					<template v-else-if="'video' === file.resType">
						<video style="width: 100%; height: 100%">
							<source :src="file.url" />
						</video>
					</template>
				</div>
			</template>
		</van-uploader>
		<van-image-preview
			v-model:show="showPreview"
			:images="
				fileList.map((item, i) => {
					return `${i}`;
				})
			"
			:start-position="startPosition"
			:on-close="onClosePreview"
		>
			<template #image="{ src }">
				{{ src }}
				<template v-if="'img' === fileList[Number(src)].resType">
					<el-image style="width: 100vw; height: 100vh" :src="fileList[Number(src)].url" fit="contain" />
				</template>
				<template v-else-if="'video' === fileList[Number(src)].resType">
					<video style="width: 100vw; height: 100vh" controls>
						<source :src="fileList[Number(src)].url" />
					</video>
				</template>
			</template>
		</van-image-preview>
	</div>
</template>

<script setup>
	import { showDialog, showToast } from 'vant';
	import Compressor from 'compressorjs';
	import { isArray } from '@/utils';

	const props = defineProps({
		modelValue: [Array],
		accept: {
			type: String,
			default: '',
		},
		showUpload: {
			type: Boolean,
			default: true,
		},
		// 图片数量限制
		limit: {
			type: Number,
			default: 9,
		},
		// 大小限制(MB)
		fileSize: {
			type: Number,
			default: 5,
		},
		// 文件类型, 例如['png', 'jpg', 'jpeg']
		fileType: {
			type: Array,
			default: () => ['png', 'jpg', 'jpeg'],
		},
		// 是否显示提示
		isShowTip: {
			type: Boolean,
			default: true,
		},
		uploadProps: {
			type: Object,
		},
		convertResToFrontData: {
			type: Function,
		},
		uploadFile: {
			type: Function,
		},
	});

	const previewOptions = {
		closeable: true,
	};

	// const accept = computed({
	// 	get() {
	// 		return props.accept || 'image/*';
	// 	},
	// 	set(val) {
	// 		emit('update:accept', val);
	// 	},
	// });
	const showCamera = ref(false);
	const showVideo = ref(false);
	const onAcceptRefresh = () => {
		const propsAccept = props.accept;

		if (!propsAccept) {
			showCamera.value = true;
		} else {
			if (propsAccept.indexOf('image') > -1) {
				showCamera.value = true;
			} else {
				showCamera.value = false;
			}
			if (propsAccept.indexOf('video') > -1) {
				showVideo.value = true;
			} else {
				showVideo.value = false;
			}
		}
	};
	const accept = ref(props.accept || 'image/*');
	const onClickUpload = (ev) => {
		console.log('onClickUpload', ev);

		const { offsetX } = ev;
		console.log('offsetX', offsetX);
		if (showCamera.value && showVideo.value) {
			if (offsetX < 80) {
				onClickUploadImage();
			} else {
				onClickUploadVideo();
			}
		} else {
			// props.accept 不变 什么都不做
			if (showCamera.value) {
				// onClickUploadImage();
			} else if (showVideo.value) {
				// onClickUploadVideo();
			}
		}
	};
	const onClickUploadImage = () => {
		accept.value = 'image/*';
	};
	const onClickUploadVideo = () => {
		accept.value = 'video/*';
	};
	const startPosition = ref(0);
	const showPreview = ref(false);

	const beforeReadSingleFile = (file, callback) => {
		if (file.type.indexOf('video') > -1) {
			// 文件是视频
			showToast('正在上传视频，请稍候...');
			number.value++;
			callback(file);
		} else if (file.type.indexOf('image') > -1) {
			// 文件是图片
			beforeReadSingleFileImage(file, callback);
		}
	};

	const beforeReadSingleFileImage = (file, callback) => {
		// 文件是图片
		let quality = 1;
		if (file.size < 1000 * 1000) {
			//小于1M
			quality = 0.8;
		} else if (file.size < 5000 * 1000) {
			//小于5M
			quality = 0.5;
		} else if (file.size < 10000 * 1000) {
			//小于10M
			quality = 0.3;
		} else {
			//大于10M
			quality = 0.1;
		}
		// quality = 1;
		// compressorjs 默认开启 checkOrientation 选项
		// 会将图片修正为正确方向
		console.log('Compressor.before.file', file);
		new Compressor(file, {
			quality, //压缩比例0-1
			// success: resolve,
			success: (file) => {
				console.log('Compressor.success.file', file);

				//blob转file,因为大文件会被转成blob类型
				file = new File([file], file.name, { type: file.type, lastModified: Date.now() }); //blob转file

				const b = handleBeforeUploadImage(file);
				if (b) {
					// console.log('resolve.file', file);
					callback(file);
				}
			},
			error(err) {
				console.log(err.message);
			},
		});
	};

	const beforeRead = (file) =>
		new Promise((resolve) => {
			// console.log('beforeRead.file', file);
			let num = 0;
			const files = [];
			let filesLength = file.length || 1;
			const callback = (file) => {
				if (filesLength === 1) {
					resolve(file);
				} else {
					num++;
					files.push(file);
					if (filesLength === num) {
						resolve(files);
					}
				}
			};
			if (isArray(file)) {
				filesLength = file.length;
				file.map((file) => {
					beforeReadSingleFile(file, callback);
				});
			} else {
				beforeReadSingleFile(file, callback);
			}
		});

	const afterReadSingleFile = async (file) => {
		// 此时可以自行将文件上传至服务器
		console.log('afterRead', file);
		// console.log(file.file);
		file.status = 'uploading';
		file.message = '上传中...';
		try {
			const res = await props.uploadFile(file.file, '');
			// console.log('res', res);
			handleUploadSuccess({
				data: res,
			});
			file.status = 'done';
			file.message = '上传完成';
		} catch (error) {
			file.status = 'failed';
			file.message = '上传失败';
		}
	};

	const afterRead = async (file) => {
		// 此时可以自行将文件上传至服务器
		//console.log('afterRead', file);
		if (isArray(file)) {
			file.map((file) => {
				afterReadSingleFile(file);
			});
		} else {
			afterReadSingleFile(file);
		}
	};

	const clickPreview = async (file) => {
		// 预览文件
		console.log('click-preview', file);
		startPosition.value = file.index;
		showPreview.value = true;
	};

	const onClosePreview = () => {
		showPreview.value = false;
	};

	const emit = defineEmits(['update:modelValue', 'update:accept']);
	const number = ref(0);
	const uploadList = ref([]);
	const fileList = ref([]);
	// const showTip = computed(() => props.isShowTip && (props.fileType || props.fileSize));

	watch(
		() => props.modelValue,
		(val) => {
			//console.log('props.modelValue', val);
			if (val) {
				// 首先将值转为数组
				const list = Array.isArray(val) ? val : props.modelValue.split(',');
				// 然后将数组转为对象数组
				fileList.value = list.map((item) => {
					if (typeof item === 'string') {
						item = { name: item, url: item, isImage: true };
					} else if (!item.url || !item.name) {
						item = convertResToFrontDataInner(item);
					}
					return item;
				});
			} else {
				fileList.value = [];
				return [];
			}
		},
		{ deep: true, immediate: true },
	);

	// 删除图片
	function handleRemove(_file, detail) {
		fileList.value = fileList.value.filter((item, i) => {
			return i != detail.index;
		});
		emit('update:modelValue', listToArray(fileList.value));
	}

	/**
	 * 根据后端返回的数据进行处理成前端展示用的数据
	 * @param {*} data
	 */
	function convertResToFrontDataInner(data) {
		if (props.convertResToFrontData) {
			return props.convertResToFrontData(data);
		}
		return data;
	}

	// 上传成功回调
	function handleUploadSuccess(res) {
		//console.log('handleUploadSuccess.res', res);
		const frontData = convertResToFrontDataInner(res.data);
		uploadList.value.push(frontData);
		//console.log('uploadList.value.length', uploadList.value.length);
		if (uploadList.value.length === number.value) {
			//console.log('fileList.value', fileList.value);
			fileList.value = fileList.value
				.filter((f) => f.url !== undefined && f.url.indexOf('blob:') !== 0)
				.concat(uploadList.value);
			uploadList.value = [];
			//console.log('fileList.value', fileList.value);

			number.value = 0;
			emit('update:modelValue', listToArray(fileList.value));
			// modal.closeLoading();
		}
	}

	// 上传前loading加载
	function handleBeforeUploadImage(file) {
		// console.log('handleBeforeUploadImage.file', file);
		let isImg = false;
		if (props.fileType.length) {
			let fileExtension = '';
			if (file.name.lastIndexOf('.') > -1) {
				fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
			}
			isImg = props.fileType.some((type) => {
				if (file.type.indexOf(type) > -1) return true;
				if (fileExtension && fileExtension.indexOf(type) > -1) return true;
				return false;
			});
		} else {
			isImg = file.type.indexOf('image') > -1;
		}
		if (!isImg) {
			showDialog({ message: `文件格式不正确, 请上传${props.fileType.join('/')}图片格式文件!` });
			return false;
		}
		if (props.fileSize) {
			const isLt = file.size / 1024 / 1024 < props.fileSize;
			if (!isLt) {
				showDialog({ message: `上传头像图片大小不能超过 ${props.fileSize} MB!` });
				return false;
			}
		}
		// showDialog({ message: '正在上传图片，请稍候...' });
		showToast('正在上传图片，请稍候...');
		number.value++;
		return true;
	}

	// 对象转成指定数组格式
	function listToArray(list) {
		return list.map((i) => i);
	}

	// 对象转成指定字符串分隔
	// function listToString(list, separator) {
	// 	let strs = '';
	// 	separator = separator || ',';
	// 	for (const i in list) {
	// 		if (undefined !== list[i].url && list[i].url.indexOf('blob:') !== 0) {
	// 			strs += list[i].url.replace(baseUrl, '') + separator;
	// 		}
	// 	}
	// 	return strs != '' ? strs.substr(0, strs.length - 1) : '';
	// }
	// listToString();

	watch(
		() => props.accept,
		() => {
			onAcceptRefresh();
		},
		{ immediate: true },
	);
</script>

<style scoped lang="scss">
	// .el-upload--picture-card 控制加号部分
	:deep(.hide .el-upload--picture-card) {
		display: none;
	}

	.upload-input-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.upload-input-icon {
		width: 80px;
		height: 80px;
		margin: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--van-uploader-upload-background);
	}

	.preview-cover {
		position: absolute;
		bottom: 0;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 4px;
		color: #fff;
		font-size: 12px;
		text-align: center;
		// background: rgba(0, 0, 0, 1);
		background: var(--van-uploader-upload-background);
	}
</style>
